import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=701eb508&scoped=true"
import script from "./BaseModal.vue?vue&type=script&lang=js"
export * from "./BaseModal.vue?vue&type=script&lang=js"
import style0 from "./BaseModal.vue?vue&type=style&index=0&id=701eb508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701eb508",
  null
  
)

export default component.exports